import type {
  AccountActivity,
  AdminOverview,
  AdminUser,
  CustomerProfile,
  GeneratedResult,
  PublicConfig,
} from "../types";

const json = async <T>(response: Response): Promise<T> => {
  const body = (await response.json()) as T & { error?: string };
  if (!response.ok) throw new Error(body.error ?? "Qualcosa non ha funzionato.");
  return body;
};

export const loadConfig = () => fetch("/api/config").then(json<PublicConfig>);

export const createVaffangoogle = (input: {
  situation: string;
}) =>
  fetch("/api/generate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  }).then(
    json<GeneratedResult & { credits: number }>,
  );

export const createCheckout = (packId: string) =>
  fetch("/api/checkout", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ packId, attemptId: crypto.randomUUID() }),
  }).then(json<{ url: string }>);

export const checkCheckout = (sessionId: string) =>
  fetch(`/api/checkout/status?session_id=${encodeURIComponent(sessionId)}`).then(
    json<{ paid: boolean; granted: boolean; credits: number }>,
  );

type AccountResult = {
  profile: CustomerProfile | null;
  credits: number;
};

const accountRequest = (
  action: "register" | "login",
  input: { email: string; password: string },
) =>
  fetch(`/api/account/${action}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  }).then(json<AccountResult>);

export const registerAccount = (input: { email: string; password: string }) =>
  accountRequest("register", input);

export const loginAccount = (input: { email: string; password: string }) =>
  accountRequest("login", input);

export const logoutAccount = () =>
  fetch("/api/account/logout", { method: "POST" }).then(json<AccountResult>);

export const loadAccountActivity = () =>
  fetch("/api/account/activity").then(
    json<{ activity: AccountActivity[] }>,
  );

export const loadAdminOverview = () =>
  fetch("/api/admin/overview", { cache: "no-store" }).then(json<AdminOverview>);

export const loadAdminUsers = (query = "") =>
  fetch(`/api/admin/users?q=${encodeURIComponent(query)}&limit=100`, {
    cache: "no-store",
  }).then(json<{ total: number; users: AdminUser[] }>);

export const grantAdminCredits = (input: {
  accountIds: string[];
  credits: number;
  reason: string;
}) =>
  fetch("/api/admin/credits", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  }).then(json<{ updated: number; users: AdminUser[] }>);
